import { ApproveRequestAction } from "common/types/workflows";

export const isApproveRequestActionValid = (action: ApproveRequestAction) =>
  !!(action && action.formId !== undefined);
